/**
 * Standalone Advisors product root (`/advisors`).
 *
 * When Advisors is embedded under Request Workspace, use `useAdvisorsPaths()` or
 * `resolveAdvisorsBase(asPath)` from `./paths` so links stay under
 * `/requests/manage/:id/advisors`. These constants remain the standalone defaults
 * (emails, redirects, non-router contexts).
 */
export const ADVISORS_BASE = '/advisors'

/** Wil Tool slug — must match backend `ADVISOR_WIL_TOOL_SLUG`. */
export const ADVISOR_WIL_TOOL_SLUG = 'advisor-wil'

/** Ask Wil entry (session list / chat). Standalone default — prefer `useAdvisorsPaths().ask`. */
export const ADVISORS_ASK_PATH = `${ADVISORS_BASE}/ask`

/**
 * Fallback product name when backend data is not yet available.
 * Prefer `advisorUser.fullName` / tool title from the API when present.
 */
export const WIL_DISPLAY_NAME = 'Wil.ai'

/** Canonical Wil avatar path (prefer API pictureUrl when present). */
export const WIL_AVATAR = '/assets/people/wil.jpg'

/** Seat management routes (FE-2 recruit flow). Standalone default. */
export const ADVISORS_SEATS_BASE = `${ADVISORS_BASE}/seats`

export const ADVISORS_OPPORTUNITIES_PATH = `${ADVISORS_BASE}/opportunities`

/** Full searchable lists opened from sidebar "View All..." links. Standalone defaults. */
export const ADVISORS_MY_ADVISORS_ALL_PATH = `${ADVISORS_BASE}/my-advisors/all`
export const ADVISORS_MY_FOUNDERS_ALL_PATH = `${ADVISORS_BASE}/my-founders/all`

/** Upgrade / paywall landing. Standalone default. */
export const ADVISORS_UPGRADE_PATH = `${ADVISORS_BASE}/upgrade`

/** Paid Stream video sessions (AdvisorSession). Standalone default. */
export const ADVISORS_SESSIONS_PATH = `${ADVISORS_BASE}/sessions`

/** Expert payouts (Connect + ledger). Standalone default. */
export const ADVISORS_PAYOUTS_PATH = `${ADVISORS_BASE}/profile/payouts`

/** Topic discovery (large category tiles). Standalone default. */
export const ADVISORS_BROWSE_PATH = `${ADVISORS_BASE}/browse`

/** Advisor results grid + compact filters (keywords, topics). Standalone default. */
export const ADVISORS_DIRECTORY_PATH = `${ADVISORS_BASE}/directory`

/** Advisor profile shell (members profile body + Advisors chrome). Standalone default. */
export const ADVISORS_PROFILE_PATH = `${ADVISORS_BASE}/profile`

/**
 * Advisors Recruit / Manage / Tools chrome. On in every non-production deployment.
 */
export const ADVISORS_FEATURES_ENABLED =
  true ||
  (process.env.NEXT_PUBLIC_ADVISORS_VERSION === 'v1'
    ? false
    : process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production')

export const ADVISOR_FEATURE_RECRUIT_ENABLED = ADVISORS_FEATURES_ENABLED
export const ADVISOR_FEATURE_MANAGE_ENABLED = ADVISORS_FEATURES_ENABLED
export const ADVISOR_FEATURE_TOOLS_CHROME_ENABLED = ADVISORS_FEATURES_ENABLED

/** Max items shown on the View All list pages (client-side boards / page size for paginated lists). */
export const ADVISORS_VIEW_ALL_LIST_LIMIT = 50

/** First page of the Find advisors directory grid. */
export const ADVISORS_DIRECTORY_PAGE_SIZE = 24

/** Page size for server-paginated My Founders "View all" list. */
export const ADVISORS_MY_FOUNDERS_PAGE_SIZE = 25

/** Max cards on the My Founders landing grid (full roster is /my-founders/all). */
export const ADVISORS_MY_FOUNDERS_GRID_SIZE = 12

/** Backend orderBy for My Founders activity lists. */
export const ADVISORS_ORDER_BY_LAST_ACTIVITY = 'lastActivity'
